import {ActivatedRouteSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {TrackService} from './track.service';
import {Shipment} from '../domain/shipment';
import {HttpErrorResponse} from '@angular/common/http';

@Injectable()
export class TrackResolver {
  constructor(private trackService: TrackService) {
  }

  resolve(route: ActivatedRouteSnapshot): Promise<Shipment | HttpErrorResponse> {
    const query = route.paramMap.get('query');

    try {
      return this.trackService.getShipment(query);
    } catch (e) {
      return e;
    }
  }
}
